import React from 'react';
import styled from 'styled-components';
import { List, GravityProvider, Logo, GvIcon } from '@shore/react-gravity';

//TODO: Work on this app later.
export function Locations() {
  return (
    <div style={{ width: '100%', height: '100%' }}>
      <GravityProvider>
        {/* Locations Screen
        <Logo name="group-one" />
        <List>
          <tr>
            <td>Test Row</td>
          </tr>
        </List> */}
        {/* 
        <header className="gv-main-header">
          <div className="gv-header-nav">
            <div className="gv-nav-left">
              <button type="button" className="gv-btn-menu" aria-label="Menu">
                <GvIcon iconName="menu" />
              </button>
              <a href="/" className="gv-logo" aria-label="Homepage">
                <gv-logo src="/logos/group-one.svg"></gv-logo>
              </a>
            </div>
            <nav className="gv-nav-links">
              <ul>
                <li>
                  <a href="# ">Menu link</a>
                </li>
                <li>
                  <a href="# ">Menu link</a>
                </li>
              </ul>
            </nav>
            <div className="gv-nav-menu">
              <a
                href="# "
                className="gv-btn-notification"
                aria-label="Notifications"
              >
                <gv-icon
                  aria-hidden="true"
                  src="/icons/notifications.svg"
                ></gv-icon>
              </a>
              <button
                type="button"
                className="gv-btn-search"
                aria-label="Search"
              >
                <gv-icon aria-hidden="true" src="/icons/search.svg"></gv-icon>
              </button>
              <a href="#" className="gv-btn-cart" aria-label="Cart">
                <gv-icon
                  aria-hidden="true"
                  src="/icons/shopping_cart.svg"
                ></gv-icon>
                <span className="gv-amount">0</span>
              </a>
              <button type="button" className="gv-btn-account">
                <gv-icon
                  aria-hidden="true"
                  src="/icons/account_circle.svg"
                ></gv-icon>
                <span className="gv-btn-label">Account</span>
              </button>
            </div>
          </div>
          <div className="gv-sidedrawer gv-slide-in">
            <div className="gv-side-content">
              <button type="button" className="gv-btn-close" aria-label="Close">
                <gv-icon aria-hidden="true" src="/icons/close.svg"></gv-icon>
              </button>
              <div>
                Use this sidedrawer for the mobile menu. Check out the
                <a href="/sidedrawer">sidedrawer documentation</a> for the
                content and behaviour of the sidedrawer.
              </div>
            </div>
          </div>
          <div className="gv-sidedrawer gv-slide-in">
            <div className="gv-side-content gv-pos-right">
              <button type="button" className="gv-btn-close" aria-label="Close">
                <gv-icon aria-hidden="true" src="/icons/close.svg"></gv-icon>
              </button>
              <div>
                Use this sidedrawer for the account menu. Check out the
                <a href="/sidedrawer">sidedrawer documentation</a> for the
                content and behaviour of the sidedrawer.
              </div>
            </div>
          </div>
        </header> */}

        {/* <Divider /> */}

        <Logo name="group-one" />
        <main id="main-content" className="gv-surface-dim">
          <div className="gv-flex gv-mx-auto gv-w-max-container">
            <div className="gv-sidebar gv-max-tab-hidden">
              <div className="gv-side-menu">
                <div className="gv-side-label">
                  <GvIcon iconName="account_circle" />
                  <GvIcon iconName="18_up_rating" />
                </div>
                {/* <nav className="gv-side-nav">
                  <ul>
                    <li>
                      <a href="#" className="gv-nav-item gv-active">
                        <gv-icon
                          aria-hidden="true"
                          src="/icons/account_circle.svg"
                        ></gv-icon>
                        <span>Label</span>
                      </a>
                    </li>
                    <li>
                      <a href="#" className="gv-nav-item">
                        <gv-icon
                          aria-hidden="true"
                          src="/icons/account_circle.svg"
                        ></gv-icon>
                        <span>Label</span>
                      </a>
                    </li>
                    <li>
                      <a href="#" className="gv-nav-item">
                        <gv-icon
                          aria-hidden="true"
                          src="/icons/account_circle.svg"
                        ></gv-icon>
                        <span>Label</span>
                      </a>
                    </li>
                    <li>
                      <a href="#" className="gv-nav-item">
                        <gv-icon
                          aria-hidden="true"
                          src="/icons/account_circle.svg"
                        ></gv-icon>
                        <span>Label</span>
                      </a>
                    </li>
                    <li>
                      <a href="#" className="gv-nav-item">
                        <gv-icon
                          aria-hidden="true"
                          src="/icons/account_circle.svg"
                        ></gv-icon>
                        <span>Label</span>
                      </a>
                    </li>
                    <li>
                      <a href="#" className="gv-nav-item">
                        <gv-icon
                          aria-hidden="true"
                          src="/icons/account_circle.svg"
                        ></gv-icon>
                        <span>Label</span>
                      </a>
                    </li>
                  </ul>
                </nav> */}
              </div>
            </div>
            <div className="gv-flex-1 gv-p-fluid">Content</div>
          </div>
        </main>
      </GravityProvider>
    </div>
  );
}
